import React from 'react';
import { Phone, Mail, MapPin, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-[#020d2a] text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              <img 
                src="/orion-logo-footer.png" 
                alt="Orion Industrie" 
                className="h-20 w-auto"
              />
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              <span className="block mb-2 font-semibold text-[#FF6600]">Sécuriser • Équiper • Fiabiliser</span>
              <span className="block">Solutions d'équipements de quai pour la sécurité de vos installations logistiques.</span>
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/in/benoit-manin-b25991365/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#020d2a] rounded-full flex items-center justify-center hover:bg-[#FF6600] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="hover:text-#E67E22 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('products')}
                  className="hover:text-#E67E22 transition-colors"
                >
                  Nos Produits
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('advantages')}
                  className="hover:text-#E67E22 transition-colors"
                >
                  Notre Expertise
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-#E67E22 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Nos Services</h4>
            <ul className="space-y-3">
              <li className="hover:text-#E67E22 transition-colors cursor-pointer">
                Installation de ponts hydrauliques
              </li>
              <li className="hover:text-#E67E22 transition-colors cursor-pointer">
                Mise en conformité sécurité
              </li>
              <li className="hover:text-#E67E22 transition-colors cursor-pointer">
                Maintenance et SAV
              </li>
              <li className="hover:text-#E67E22 transition-colors cursor-pointer">
                Conseil personnalisé
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-#E67E22 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-gray-400">Téléphone</p>
                  <a href="tel:0659452562" className="hover:text-#E67E22 transition-colors">
                    06 59 45 25 62
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-#E67E22 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <a href="mailto:gestion@orion-industrie.eu" className="hover:text-[#E67E22] transition-colors">
                    gestion@orion-industrie.eu
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-#E67E22 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-sm text-gray-400">Localisation</p>
                  <p>France</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p className="text-gray-400 mb-4 md:mb-0">
              © {currentYear} Orion Industrie. Tous droits réservés.
            </p>
            <div className="flex space-x-6">
              <Link to="/mentions-legales" className="text-gray-400 hover:text-#E67E22 transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-gray-400 hover:text-#E67E22 transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
